import QRCode from 'qrcode';

import template from './QrCodeTemplate';

const WINDOW_SIZE_BOUNDS = { min: 128, max: 512 };

type Options = {
  value: string;
  size?: number;
  fileName?: string;
  title?: string;
  showGoToLink?: boolean;
};

export const showQrCodeModal = async ({
  value,
  size = 1024,
  fileName = 'qr-code',
  title = 'QR Code',
  showGoToLink = true
}: Options) => {
  const imgUrl = await QRCode.toDataURL(value, { width: size });
  const windowSize = Math.min(
    Math.max(size, WINDOW_SIZE_BOUNDS.min),
    WINDOW_SIZE_BOUNDS.max
  );
  const qrCodeWindow = window.open(
    '',
    '_blank',
    `width=${windowSize + 100},height=${windowSize + 150}`
  );
  if (!qrCodeWindow) {
    throw new Error('Não foi possível abrir a janela para exibir o QR Code');
  }
  qrCodeWindow.document.open();
  const htmlContent = template({
    qrCodeTitle: title,
    qrCodeUrl: imgUrl,
    qrCodeFileName: fileName,
    link: showGoToLink ? value : undefined
  });
  qrCodeWindow.document.writeln(htmlContent);
  qrCodeWindow.document.close();
  return qrCodeWindow;
};
